import React from "react";
import { includes } from "lodash";
import { Tag } from "primereact/tag";
import { useTranslation } from "react-i18next";

const OrderDamageCaseLabelBadge = (props: any) => {
    const { labelFor } = props;
    const { t } = useTranslation();

    if (!labelFor) {
        return null;
    }

    const labelLower = labelFor.toLowerCase();

    // Success for EFL
    if (includes(['efl'], labelLower)) {
        return <Tag value={t(labelFor)} severity="success" />;
    }

    // Info for Compound
    if (includes(['compound'], labelLower)) {
        return <Tag value={t(labelFor)} severity="info" />;
    }

    // Warning for Carrier
    if (includes(['carrier'], labelLower)) {
        return <Tag value={t(labelFor)} severity="warning" />;
    }

    // Contrast for Dekra
    if (includes(['dekra'], labelLower)) {
        return <Tag value={t(labelFor)} severity="warning" />;
    }

    // Default
    return <Tag value={t(labelFor)} severity="warning" />;
};

export default OrderDamageCaseLabelBadge;

